"use client";

import React from 'react';
import { Form, Button } from "react-bootstrap";

interface ProductQuantityProps {
  quantity: number;
  onChange: (quantity: number) => void;
}

const ProductQuantity: React.FC<ProductQuantityProps> = ({ 
  quantity = 1,
  onChange 
}) => {
  const handleIncrement = () => {
    onChange(quantity + 1);
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      onChange(quantity - 1);
    }
  };

  return (
    <div className="product-quantity">
      <div className="add-to-cart-counter d-flex align-items-center">
        <Button className="minusBtn" onClick={handleDecrement}>
          -
        </Button>
        <Form.Control
          type="text"
          className="form-control counterValue"
          value={quantity}
          readOnly
        />
        <Button className="plusBtn" onClick={handleIncrement}>
          +
        </Button>
      </div>
    </div>
  );
};

export default ProductQuantity;
